import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import debounce from 'lodash.debounce';

import { parentScroll } from '../utils/parentScroll';
import { inViewport } from '../utils/inViewport';

class SharedInViewport extends Component {
    constructor(props) {
        super(props);

        this.inViewportHandler = debounce(this.inViewportHandler, 250);
    }

    state = {
        inViewport: false,
    };

    componentDidMount() {
        const eventNode = this.getEventNode();
        this.inViewportHandler();

        window.addEventListener('resize', this.inViewportHandler);
        eventNode.addEventListener('scroll', this.inViewportHandler);
    }

    componentWillUnmount() {
        this.detachListeners();
    }

    getEventNode() {
        return parentScroll(findDOMNode(this));
    }

    inViewportHandler = () => {
        const node = findDOMNode(this);
        const eventNode = this.getEventNode();

        if (inViewport(node, eventNode)) {
            const { stopWhenInViewport } = this.props;
            if (stopWhenInViewport) {
                this.detachListeners();
            }

            this.handleState({ inViewport: true });
        } else {
            this.handleState({ inViewport: false });
        }
    };

    handleState(state = {}) {
        const { onInViewportChange } = this.props;

        this.setState(state, () => {
            if (onInViewportChange) {
                onInViewportChange(state);
            }
        });
    }

    detachListeners() {
        const eventNode = this.getEventNode();

        window.removeEventListener('resize', this.inViewportHandler);
        eventNode.removeEventListener('scroll', this.inViewportHandler);
    }

    render() {
        const { children } = this.props;

        return (
            <Fragment>{typeof children === 'function' ? children(this.state) : children}</Fragment>
        );
    }
}

SharedInViewport.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
    onInViewportChange: PropTypes.func,
    stopWhenInViewport: PropTypes.bool,
};

SharedInViewport.defaultProps = {
    stopWhenInViewport: false,
};

export { SharedInViewport };
